import { render, staticRenderFns } from "./TestAnswers.vue?vue&type=template&id=7d0c57ca&scoped=true"
import script from "./TestAnswers.vue?vue&type=script&lang=js"
export * from "./TestAnswers.vue?vue&type=script&lang=js"
import style0 from "./TestAnswers.vue?vue&type=style&index=0&id=7d0c57ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d0c57ca",
  null
  
)

export default component.exports